export const ArrowUpRight = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M25 22V7H10" stroke="currentColor" stroke-width="2"/>
<path d="M6.69379 25.3062L25 7" stroke="currentColor" stroke-width="2"/>
</svg>`;
